import styled from 'styled-components';

//components
import { Section } from '@/containers-ai/SectionHeading';
import { Container } from '@/components/Grid';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const AssistanceSection = styled(Section)`
  background: ${homeColor.bg};
`;

export const AssistanceInner = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  text-align: center;

  ${screen.md} {
    align-items: flex-start;
    text-align: left;
  }
`;

export const AssistanceTitle = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.25;
  font-size: 38px;
  margin: 0;
  color: ${homeColor.white};

  ${screen.xxlg} {
    font-size: 48px;
  }
`;

export const AssistanceGrid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;

  ${screen.md} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  ${screen.xxlg} {
    gap: 200px;
    justify-content: flex-start;
  }
`;

export const AssistanceCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: ${getToken('font-family-title')};
`;

export const AssistanceCardTitle = styled.p`
  font-weight: 700;
  font-size: 21px;
  color: ${homeColor.green};
  margin: 0 0 4px;

  ${screen.md} {
    font-size: 24px;
  }

  ${screen.xxlg} {
    font-size: 26px;
  }
`;

export const AssistanceCardText = styled.p`
  font-weight: 400;
  font-size: 21px;
  color: ${homeColor.muted};
  margin: 0;

  ${screen.md} {
    font-size: 24px;
  }

  ${screen.xxlg} {
    font-size: 26px;
  }
`;
